import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// import config from "config/config.js";

// react component for creating dynamic tables
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Button from "components/CustomButtons/Button.js";

// import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

const useStyles = makeStyles(menuStyle);

export default function AddItemCustom(props) {
  const {
    cart,
    currency,
    customStyle,
    // selectItem,
    quantity,
    updateQuantity,
    isIngredientsPerHg,
    totPrice,
    isSize,
    type,
    showQuantity,
    showEdit,
    singlePrice,
  } = props;

  const classes = useStyles();

  const { t } = useTranslation();

  function checkCartQuantity(cartToCheck) {
    var totQuantity = 0;
    if (cartToCheck.length !== 0) {
      cartToCheck.forEach((element) => {
        totQuantity += element.quantity;
      });
    }
    if (totQuantity <= 7) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <>
      {!showQuantity && isIngredientsPerHg ? null : (
        <div>
          {showEdit ? (
            <Button
              round
              size="sm"
              color="transparent"
              className={classes.buttonSmall}
              onClick={() => {
                updateQuantity("minus");
              }}
              style={{
                borderColor: customStyle.buttonAction,
                color: customStyle.buttonAction,
              }}
              disabled={type === "add" && quantity === 1}
            >
              <span
                className={classes.buttonText}
                style={{ color: customStyle.buttonAction }}
              >
                -
              </span>
            </Button>
          ) : null}

          <span
            className={classes.priceText}
            style={{ paddingLeft: "10px", paddingRight: "10px" }}
          >
            {quantity}
          </span>
          {showEdit ? (
            checkCartQuantity(cart) && (
              <Button
                round
                size="sm"
                color="transparent"
                className={classes.buttonSmall}
                // color="info"
                onClick={() => {
                  updateQuantity("plus");
                }}
                disabled={isSize}
                style={{
                  borderColor: customStyle.buttonAction,
                  color: customStyle.buttonAction,
                }}
              >
                <span
                  className={classes.buttonText}
                  style={{ color: customStyle.buttonAction }}
                >
                  +
                </span>
              </Button>
            )
          ) : (
            <span style={{ fontSize: "13px" }}>x{singlePrice}€</span>
          )}

          {type === "add" || isIngredientsPerHg ? null : (
            <div
              className={classes.priceText}
              style={{ float: "right", textAlign: "right" }}
            >
              {`${
                totPrice
                  ? `${totPrice} ${
                      currency && currency.symbol ? currency.symbol : ""
                    }`
                  : ""
              }`}
            </div>
          )}
        </div>
      )}
      {type === "add" ? (
        <div
          className={classes.priceText}
          style={{
            textAlign: "center",
            fontSize: "15px",
            lineHeight: "20px",
          }}
        >
          <>
            {`${t("menuList.total_button").toUpperCase()} ${
              totPrice
                ? `${totPrice} ${
                    currency && currency.symbol ? currency.symbol : ""
                  }`
                : ""
            }`}
          </>
        </div>
      ) : null}
    </>
  );
}

AddItemCustom.propTypes = {
  currency: PropTypes.shape({
    name: PropTypes.string,
    rate: PropTypes.number,
    symbol: PropTypes.string,
  }).isRequired,
  selectItem: PropTypes.objectOf(PropTypes.any).isRequired,
  quantity: PropTypes.number.isRequired,
  updateQuantity: PropTypes.func.isRequired,
  isIngredientsPerHg: PropTypes.bool,
  customStyle: PropTypes.object,
  ingredientC: PropTypes.object,
  customIngredients: PropTypes.arrayOf(PropTypes.object),

  totPrice: PropTypes.string.isRequired,
  isSize: PropTypes.bool.isRequired,
  type: PropTypes.string,
  showQuantity: PropTypes.bool,
  showEdit: PropTypes.bool,
  singlePrice: PropTypes.string,
};
AddItemCustom.defaultProps = {
  customStyle: {},
  isIngredientsPerHg: false,
  ingredientC: {},
  customIngredients: [],
  type: "add",
  showQuantity: true,
  showEdit: true,
  singlePrice: "",
};
